import styled from "styled-components";

export const InfoItem = styled.li`
  gap: 10px;
  display: flex;
  flex-direction: column;
`;

export const InfoItemTitle = styled.div`
  color: ${(props) => props.theme.colors.black100};
  font-size: 1.6rem;
  font-weight: 700;
`;

export const InfoItemList = styled.ul`
  gap: 26px;
  display: flex;
  padding: 24px;
  background: ${(props) => props.theme.colors.white100};
  box-shadow: ${(props) => props.theme.shadows.box};
  border-radius: 10px;
  flex-direction: column;
`;
